/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/features/admin-business-profiles/components/filter/filter.component.scss */
.iot4bos-ui-backoffice-filter-bp-by-name-form {
  position: sticky;
  top: 0;
  z-index: 1;
}
.iot4bos-ui-backoffice-filter-bp-by-name-form .name-field {
  width: calc(100% - 2rem);
  padding: 1rem 1rem 0 1rem;
}
/*# sourceMappingURL=filter.component.css.map */
